import { Dialog } from "vant";
import store from "@/store";
import router from "@/router";
// 显示入馆统计弹窗
function showAdmissionDialog(data) {
  // 格式化日期
  const dateStr = data.checkTime.split(" ")[0]; // 2026-04-16
  const yearStr = dateStr.split("-")[0]; // 2026

  let countdown = store.state.pauseSecond;
  let timer = null;

  // 1. 构建自定义 HTML，调整了 line-height 和 padding 以符合截图紧凑的视觉效果
  function highLight(text) {
    return `<span style="color: #1989fa; font-weight: bold;">${text}</span>`;
  }
  const htmlContent = `
    <div class="admission-content" style=" line-height: 1.6; text-align: left; padding: 8px 0 0 0;">
      <div>您是${highLight(`今天（${dateStr}）`)}入馆的第${highLight(
    `${data.todayCount}位`
  )}</div>
      <div>您是${highLight(`今年${yearStr}年）`)}入馆的第${highLight(
    `${data.yearCount}位`
  )}</div>
      <div>您是${highLight("历史")}入馆的第${highLight(
    `${data.historyCount}位`
  )}</div>
      <div>这是您第${highLight(`${data.myCount}次`)}参观温州科技馆</div>
      <div style="text-align: right; color: #999; margin-top: 10px; font-size: 12px;">检票时间：${highLight(
    `${data.checkTime}`
  )}</div>
    </div>
    <!-- 底部自定义区域 -->
    <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 15px; border-top: 1px solid #f5f5f5; padding-top: 15px;">
      <button id="dialog-close-btn" style="background: #1989fa; color: #fff; border: none; padding: 5px 16px; border-radius: 4px; font-size: 14px; cursor: pointer;">关闭弹窗</button>
      <span style="color: #666; font-size: 12px;">倒计时 <span id="dialog-countdown-text">${countdown}</span> 秒后自动关闭</span>
    </div>
  `;

  // 2. 调用 Vant 函数式 Dialog
  Dialog({
    title: "入馆位次统计",
    message: htmlContent,
    showConfirmButton: false, // 隐藏 Vant 默认的确认按钮
    showCancelButton: false,
    allowHtml: true, // 允许渲染 HTML
    className: "custom-admission-dialog",

    // 3. 在弹窗完全渲染并打开后执行（替代原版 setTimeout 绑定 DOM）
    onOpened: () => {
      const closeBtn = document.getElementById("dialog-close-btn");
      if (closeBtn) {
        closeBtn.onclick = () => {
          clearInterval(timer);
          Dialog.close(); // 使用静态方法关闭
        };
      }

      // 开启倒计时
      timer = setInterval(() => {
        countdown--;
        const countdownText = document.getElementById("dialog-countdown-text");
        if (countdownText) {
          countdownText.innerText = countdown;
        }
        if (countdown <= 0) {
          clearInterval(timer);
          Dialog.close(); // 使用静态方法关闭
        }
      }, 1000);
    },

    // 4. 弹窗关闭后的安全清理（防止路由跳转或快速关闭后定时器还在跑）
    onClosed: () => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    },
  });
}
export function createWebSocket(
  userId,
  { onMessage, onOpen, onClose, onError }
) {
  // 1. 创建 WebSocket 实例
  let baseUrl = "";
  if (process.env.NODE_ENV === "development") {
    baseUrl = "wss://www.wzstm.cn/cloud/ws";
  } else {
    baseUrl = location.origin;
  }

  const url =
    baseUrl.replace("http", "ws") + "/message" + `?userId=${userId}&ip=1.1.1.1`;
  const ws = new WebSocket(url);

  // 2. 绑定事件监听
  ws.onopen = () => {
    console.log("WebSocket 连接已打开");
    onOpen && onOpen();
  };

  ws.onmessage = (event) => {
    console.log("收到消息:", event.data);
    onMessage && onMessage(JSON.parse(event.data));
  };

  ws.onclose = (event) => {
    console.log("WebSocket 连接已关闭");
    onClose && onClose(event);
  };

  ws.onerror = (error) => {
    console.error("WebSocket 发生错误:", error);
    onError && onError(error);
  };

  // 3. 返回 WebSocket 实例
  return ws;
}
let ws = null;
// 原有的 createWebSocket 不变...

export function luckyUserByWs(userId) {
  // 防止多次重复连接
  if (ws && ws.readyState === 1) return;

  ws = createWebSocket(userId, {
    onMessage: (data) => {
      console.log("接收到的 WebSocket 数据:", data);

      // 根据业务判断：如果 isLucky 为 1 或其他条件，触发弹窗
      if (data && data.isLucky === 1) {
        router.push({
          path: "/activityPoster",
          query: {
            type: Math.floor(Math.random() * 3) + 1,
            data: JSON.stringify({
              name: data.name,
              checkTime: data.checkTime,
              todayCount: data.todayCount,
              yearCount: data.yearCount,
              historyCount: data.historyCount,
              myCount: data.myCount,
            }),
          },
        });
      } else {
        showAdmissionDialog(data); // 调用上面封装的函数
      }
    },

    onError: (e) => {
      console.error("连接异常", e);
    },
  });
}

export function closeWs() {
  if (ws) {
    ws.close();
    ws = null;
  }
}
